import { useState } from 'react';
import { cn } from '@/lib/utils';

const TAMANHO = {
  sm: 'size-8 text-[12px]',
  md: 'size-10 text-[14px]',
  lg: 'size-20 text-[24px]',
} as const;

/** "Marcelo Brixius" vira "MB". */
export function iniciaisDe(nome: string): string {
  return nome
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0]?.toUpperCase())
    .join('');
}

/**
 * A foto redonda de quem usa o sistema; sem foto, ou se ela falhar ao carregar,
 * as iniciais no degradê da marca.
 */
export default function Avatar({
  nome,
  fotoUrl,
  tamanho = 'sm',
  className,
}: {
  nome: string;
  fotoUrl: string | null | undefined;
  tamanho?: keyof typeof TAMANHO;
  className?: string;
}) {
  // Guarda qual endereço falhou: uma foto nova que chega depois é tentada.
  const [falhou, setFalhou] = useState<string | null>(null);

  if (fotoUrl && falhou !== fotoUrl) {
    return (
      <img
        src={fotoUrl}
        alt=""
        onError={() => setFalhou(fotoUrl)}
        className={cn('shrink-0 rounded-full object-cover', TAMANHO[tamanho], className)}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-linear-to-br from-accent to-faixa font-bold text-white',
        TAMANHO[tamanho],
        className,
      )}
    >
      {iniciaisDe(nome) || '?'}
    </span>
  );
}
